import { Model } from '../model/model.class';
import { Media } from '../model/media.class';

export class MediaElement extends Model {

  public mediaElementId: number;

  constructor(
    public fileName: string,
    public type: string,
    public media: Media
  ) {super(); }
}



// WEBPACK FOOTER //
// ./src/app/model/mediaElement.class.ts